import { useCallback, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

import { useTooltipAutoClose, useTooltipPortalFade } from "../../../lib/useTooltipAutoClose";
import classes from "./BodySimpleModal.module.css";

// parent needs to have position relative !!!!!!

export default function BodySimpleModal({ isDisabled, messages, normalEvent }) {
    const messageRef = useRef(null);
    const tooltipElRef = useRef(null);
    const { isOpen, isVisible, isClosing, open, close } = useTooltipPortalFade();
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
    });

    const updateCoordinates = useCallback(() => {
        if (messageRef.current) {
            const rect = messageRef.current.getBoundingClientRect();
            setCoordinates({
                top: rect.top,
                left: rect.left + rect.width / 2,
            });
        }
    }, []);

    useLayoutEffect(() => {
        if (isOpen) {
            updateCoordinates();
        }
    }, [isOpen, updateCoordinates]);

    useTooltipAutoClose({
        isOpen,
        onClose: close,
        triggerRef: messageRef,
        tooltipRef: tooltipElRef,
        interactive: true,
    });

    const pointerEnterHandler = () => {
        open();
        updateCoordinates();
    };

    const renderPortal = () => {
        const overlayRoot = document.getElementById("overlay-root");
        if (!isVisible || !overlayRoot || !messages?.length) {
            return null;
        }
        return ReactDOM.createPortal(
            <div
                ref={tooltipElRef}
                className={`${classes.fixed_message} ${isClosing ? classes.closing : ""}`}
                style={{ top: coordinates.top, left: coordinates.left }}
                onPointerEnter={pointerEnterHandler}
                onPointerLeave={close}
            >
                {messages.map((item) => (
                    <div key={item}>{item}</div>
                ))}
            </div>,
            overlayRoot,
        );
    };

    return (
        <>
            {isDisabled && messages && messages.length > 0 ? (
                <div
                    className={classes.fixed_message_container}
                    ref={messageRef}
                    onPointerEnter={pointerEnterHandler}
                >
                    {renderPortal()}
                </div>
            ) : (
                ""
            )}

            {normalEvent && messages && messages.length > 0 ? (
                <div
                    className={classes.fixed_message_container_normal}
                    ref={messageRef}
                    onPointerEnter={pointerEnterHandler}
                >
                    {renderPortal()}
                </div>
            ) : (
                ""
            )}
        </>
    );
}
